import { X } from 'lucide-react'
import { CHAT_COPY, useChatOutboxStore } from '@/entities/chat'

export function ComposerAttachments({ conversationId }: { conversationId: number }) {
  const draft = useChatOutboxStore((state) => state.drafts[conversationId])
  const unstageFile = useChatOutboxStore((state) => state.unstageFile)
  const staged = draft?.staged ?? []

  if (staged.length === 0) return null

  return (
    <div className="flex flex-wrap gap-1.5 px-3 pb-1.5">
      {staged.map((item) => (
        <div
          key={item.id}
          className={`flex max-w-[220px] items-center gap-1.5 rounded-md border px-2 py-1 text-[12px] ${
            item.error ? 'border-bad-bd bg-bad-bg text-bad' : 'border-line bg-surface-mute text-ink-2'
          }`}
        >
          <span className="truncate">{item.error ?? item.file.name}</span>
          {item.uploading && <span className="text-[11px] text-ink-4">…</span>}
          <button
            type="button"
            aria-label={item.error ? CHAT_COPY.sendWithoutIt : 'Remove attachment'}
            title={item.error ? CHAT_COPY.sendWithoutIt : undefined}
            onClick={() => unstageFile(conversationId, item.id)}
            className="shrink-0 rounded-sm p-0.5 hover:bg-hover"
          >
            <X size={12} />
          </button>
        </div>
      ))}
    </div>
  )
}
